<template>
    <div class="page">
        <div class="page-content">
            <el-card class="box-card" header="资金数据">
                <el-descriptions :column="7" border>
                    <el-descriptions-item label-class-name="my-label" content-class-name="my-content" label="消费券">{{ getSystemAllMoney.money1 }}</el-descriptions-item>
                    <el-descriptions-item label-class-name="my-label" content-class-name="my-content" label="V购积分">{{ getSystemAllMoney.money2 }}</el-descriptions-item>
                    <el-descriptions-item label-class-name="my-label" content-class-name="my-content" label="MV积分">{{ getSystemAllMoney.money3 }}</el-descriptions-item>
                    <el-descriptions-item label-class-name="my-label" content-class-name="my-content" label="UV积分">{{ getSystemAllMoney.money4 }}</el-descriptions-item>
                    <el-descriptions-item label-class-name="my-label" content-class-name="my-content" label="V动宝">{{ getSystemAllMoney.money5 }}</el-descriptions-item>
					<el-descriptions-item label-class-name="my-label" content-class-name="my-content" label="V小宝">{{ getSystemAllMoney.money6 }}</el-descriptions-item>
					<el-descriptions-item label-class-name="my-label" content-class-name="my-content" label="V宝">{{ getSystemAllMoney.money7 }}</el-descriptions-item>
                </el-descriptions>
            </el-card>

            <el-card class="box-card" style="margin-top: 20px" header="补贴数据">
                <el-form ref='retreatForm' size='small' :inline="true" :model='inputForm' label-width='0px'>
                    <div style="display: flex;align-items: center;color: #1f1e1e">
                        <span>商家本次补贴：本次凭证(</span>
                        <el-form-item style="margin: 0 4px;">
                            <el-input style='width: 100px' size="small" v-model="subsidyData.orgCurrentVoucher" :disabled='true'></el-input>
                        </el-form-item>
                        <span>) * 本次比率(</span>
                        <el-form-item style="margin: 0 4px;">
                            <el-input style='width: 100px' size="small" v-model="(subsidyData.orgCurrentMoney / subsidyData.orgCurrentVoucher).toFixed(4)" :disabled='true'></el-input>
                        </el-form-item>
                        <span>) = 本次补贴(</span>
						<el-form-item style="margin: 0 4px;">
						    <el-input style='width: 100px' size="small" v-model="subsidyData.orgCurrentMoney" :disabled='true'></el-input>
						</el-form-item>
						<span>)</span>
                    </div>
                    <div style="display: flex;align-items: center;margin-top: 20px;color: #1f1e1e">
                        <span>当前商家可用金额(</span>
                        <el-form-item style="margin: 0 4px;">
                            <el-input style='width: 100px' size="small" v-model="subsidyData.orgCurrentAvaliable" :disabled='true'></el-input>
                        </el-form-item>
                        <span>)</span>
						
						<span> >= </span>
						
						<span>拟定需要金额(</span>
						<el-form-item style="margin: 0 4px;">
						    <el-input style='width: 100px' size="small" v-model="subsidyData.orgCurrentMoney.toFixed(4)" :disabled='true'></el-input>
						</el-form-item>
						<span>)</span>
						
						<span> ? 是否满足补贴条件(</span>
						<el-tag style="margin: 0 4px" size="small" type="success" v-if="subsidyData.orgCurrentAvaliable >= subsidyData.orgCurrentMoney">满足</el-tag>
						<el-tag style="margin: 0 4px" size="small" type="danger" v-if="subsidyData.orgCurrentAvaliable < subsidyData.orgCurrentMoney">不满足</el-tag>
						<span>)</span>
                    </div>
					<div style="margin-top:30px;"></div>
					
					
					<div style="display: flex;align-items: center;color: #1f1e1e">
					    <span>用户本次补贴：本次凭证(</span>
					    <el-form-item style="margin: 0 4px;">
					        <el-input style='width: 100px' size="small" v-model="subsidyData.userCurrentVoucher" :disabled='true'></el-input>
					    </el-form-item>
					    <span>) * 本次比率(</span>
					    <el-form-item style="margin: 0 4px;">
					        <el-input style='width: 100px' size="small" v-model="(subsidyData.userCurrentMoney / subsidyData.userCurrentVoucher).toFixed(4)" :disabled='true'></el-input>
					    </el-form-item>
					    <span>) = 本次补贴(</span>
						<el-form-item style="margin: 0 4px;">
						    <el-input style='width: 100px' size="small" v-model="subsidyData.userCurrentMoney" :disabled='true'></el-input>
						</el-form-item>
						<span>)</span>
					</div>
					<div style="display: flex;align-items: center;margin-top: 20px;color: #1f1e1e">
					    <span>当前用户可用金额(</span>
					    <el-form-item style="margin: 0 4px;">
					        <el-input style='width: 100px' size="small" v-model="subsidyData.userCurrentAvaliable" :disabled='true'></el-input>
					    </el-form-item>
					    <span>)</span>
						
						<span> >= </span>
						
						<span>拟定需要金额(</span>
						<el-form-item style="margin: 0 4px;">
						    <el-input style='width: 100px' size="small" v-model="subsidyData.userCurrentMoney.toFixed(4)" :disabled='true'></el-input>
						</el-form-item>
						<span>)</span>
						
						<span> ? 是否满足补贴条件(</span>
						<el-tag style="margin: 0 4px" size="small" type="success" v-if="subsidyData.userCurrentAvaliable >= subsidyData.userCurrentMoney">满足</el-tag>
						<el-tag style="margin: 0 4px" size="small" type="danger" v-if="subsidyData.userCurrentAvaliable < subsidyData.userCurrentMoney">不满足</el-tag>
						<span>)</span>
					</div>
					<div style="margin-top:30px;"></div>
					
					
                    <div style="display: flex;align-items: center;margin-top: 20px;color: #1f1e1e">
                        <span>当前商家补贴发放状态(</span>
                        <el-tag style="margin: 0 4px" size="small" type="success" v-if="subsidyData.sendStatusOrg == 1">蓄力中</el-tag>
                        <el-tag style="margin: 0 4px" size="small" type="danger" v-if="subsidyData.sendStatusOrg == 2">发放中</el-tag>
                        <span>)</span>
						<el-button size="mini" type="primary" @click="openSendStatus" style="margin-left: 10px;" v-if="subsidyData.sendStatusOrg == 1">开启商家发放</el-button>
                    </div>
					
					<div style="display: flex;align-items: center;margin-top: 20px;color: #1f1e1e">
					    <span>当前用户补贴发放状态(</span>
					    <el-tag style="margin: 0 4px" size="small" type="success" v-if="subsidyData.sendStatusUser == 1">蓄力中</el-tag>
					    <el-tag style="margin: 0 4px" size="small" type="danger" v-if="subsidyData.sendStatusUser == 2">发放中</el-tag>
					    <span>)</span>
						<el-button size="mini" type="primary" @click="openSendStatusUser" style="margin-left: 10px;" v-if="subsidyData.sendStatusUser == 1">开启用户发放</el-button>
					</div>
					
					
                    <div style="display: flex;align-items: center;margin-top: 20px;color: #1f1e1e">
                        <span>当前补贴手自状态(</span>
                        <el-radio-group style="margin: 0 4px;" v-model='subsidyData.subsidyStatus' @change="changeValue">
                            <el-radio :label='1'>自动</el-radio>
                            <el-radio :label='2'>手动</el-radio>
                        </el-radio-group>
                        <span>)</span>
                        <el-button size="mini" type="primary" @click="confirmStart" style="margin-left: 10px;" v-if="subsidyData.subsidyStatus == 2">开始商家补贴</el-button>
                    </div>
					
					<div style="display: flex;align-items: center;margin-top: 20px;color: #1f1e1e">
					    <span>当前补贴手自状态(</span>
					    <el-radio-group style="margin: 0 4px;" v-model='subsidyData.subsidyStatus' @change="changeValue">
					        <el-radio :label='1'>自动</el-radio>
					        <el-radio :label='2'>手动</el-radio>
					    </el-radio-group>
					    <span>)</span>
					    <el-button size="mini" type="primary" @click="confirmStartUser" style="margin-left: 10px;" v-if="subsidyData.subsidyStatus == 2">开始用户补贴</el-button>
					</div>
					
                </el-form>
            </el-card>

        </div>
    </div>
</template>

<script>
import { get, post } from '@/utils/request.js';
export default {
    data() {
        return {
            getSystemAllMoney: {
                money1: 0,//消费券,
                money2: 0,//V购积分
                money3: 0,//MV积分
                money4: 0,//UV积分
                money5: 0,//V动宝
				money6: 0,//V小宝
				money7: 0//	V宝
				
            },
			
			subsidyData:{
				globalValue15:0,
				globalValue16:0,
				globalValue17:0,
				globalValue18:0,
				orgCurrentMoney:0,
				userCurrentMoney:0,
				orgCurrentVoucher:0,
				userCurrentVoucher:0,
				
				orgCurrentAvaliable:0,
				userCurrentAvaliable:0,
				
				sendStatusOrg:0,
				sendStatusUser:0,
				subsidyStatus:0
				
			}
        };
    },
    created() {
        this.getData();
    },
    methods: {
        getData(){
            this.getAllMoney();
        },
        getAllMoney(){
            get('/shop/utils/getIncomeVoucher').then((res)=>{
                if(res.success){
                    this.getSystemAllMoney.money1 = res.incomeVoucher.userMoney;
                    this.getSystemAllMoney.money2 = res.incomeVoucher.userScore;
                    this.getSystemAllMoney.money3 = res.incomeVoucher.currency8;
                    this.getSystemAllMoney.money4 = res.incomeVoucher.currency8;
                    this.getSystemAllMoney.money5 = res.incomeVoucher.currency10;
					this.getSystemAllMoney.money6 = res.incomeVoucher.currency11;
					this.getSystemAllMoney.money7 = res.incomeVoucher.currency12;
					
					this.subsidyData.globalValue15 = res.incomeVoucher.globalValue15;
					this.subsidyData.globalValue16 = res.incomeVoucher.globalValue16;
					this.subsidyData.globalValue17 = res.incomeVoucher.globalValue17;
					this.subsidyData.globalValue18 = res.incomeVoucher.globalValue18;
					this.subsidyData.orgCurrentMoney = res.incomeVoucher.orgCurrentMoney;
					this.subsidyData.userCurrentMoney = res.incomeVoucher.userCurrentMoney;	
					this.subsidyData.orgCurrentVoucher = res.incomeVoucher.orgCurrentVoucher;
					this.subsidyData.userCurrentVoucher = res.incomeVoucher.userCurrentVoucher;
					
					this.subsidyData.orgCurrentAvaliable = this.subsidyData.globalValue15-this.subsidyData.globalValue17;
					this.subsidyData.userCurrentAvaliable = this.subsidyData.globalValue16-this.subsidyData.globalValue18;
			
                    this.subsidyData.sendStatusOrg = res.incomeVoucher.sendStatusOrg;
					this.subsidyData.sendStatusUser = res.incomeVoucher.sendStatusUser;
					this.subsidyData.subsidyStatus = res.incomeVoucher.subsidyStatus;
                }
            })
        },
		openSendStatus(val){

			let isOk = this.subsidyData.orgCurrentAvaliable >= this.subsidyData.orgCurrentMoney;
			
			if(isOk){
				post('/shop/subsidyrecord/openSendStatus',{}).then((res)=>{
				    if(res.success){
				        this.$message({
				            message: '操作成功',
				            type: 'success',
				            duration: 2000
				        });
				    }else{
				        this.$message({
				            message: res.msg,
				            type: 'error',
				            duration: 2000
				        });
				    }
				})
			}else{
				this.$message({
				    message: '不满足商家补贴条件，无法开启',
				    type: 'error',
				    duration: 2000
				});
			}
		    
		},
		openSendStatusUser(val){

			let isOk = this.subsidyData.userCurrentAvaliable >= this.subsidyData.userCurrentMoney;
			
			if(isOk){
				post('/shop/subsidyrecord/openSendStatusUser',{}).then((res)=>{
				    if(res.success){
				        this.$message({
				            message: '操作成功',
				            type: 'success',
				            duration: 2000
				        });
				    }else{
				        this.$message({
				            message: res.msg,
				            type: 'error',
				            duration: 2000
				        });
				    }
				})
			}else{
				this.$message({
				    message: '不满足用户补贴条件，无法开启',
				    type: 'error',
				    duration: 2000
				});
			}
		    
		},
        changeValue(val){
            post('/shop/subsidyrecord/changeIncomeVoucherStatus',{}).then((res)=>{
                if(res.success){
                    this.$message({
                        message: '操作成功',
                        type: 'success',
                        duration: 2000
                    });
                }else{
                    this.$message({
                        message: res.msg,
                        type: 'error',
                        duration: 2000
                    });
                }
            })
        },
        confirmStart(){
            post('/shop/subsidyrecord/startIncomeVoucher',{}).then((res)=>{
                if(res.success){
                    this.$message({
                        message: '操作成功',
                        type: 'success',
                        duration: 2000
                    });
                }else{
                    this.$message({
                        message: res.msg,
                        type: 'error',
                        duration: 2000
                    });
                }
            })
        },
		
		confirmStartUser(){
		    post('/shop/subsidyrecord/startIncomeVoucherUser',{}).then((res)=>{
		        if(res.success){
		            this.$message({
		                message: '操作成功',
		                type: 'success',
		                duration: 2000
		            });
		        }else{
		            this.$message({
		                message: res.msg,
		                type: 'error',
		                duration: 2000
		            });
		        }
		    })
		},
    }


};
</script>

<style scoped lang="scss">
::v-deep .el-input__inner{
    padding: 0 5px;
    text-align: center;
}
::v-deep .el-radio{
    margin-right: 10px;
}
</style>